import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import { TOWERS } from "../../constants/towers";
import "./admin.css";
import "./AdminNotices.css";

export default function AdminNotices() {
  const [notices, setNotices] = useState([]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [selectedTowers, setSelectedTowers] = useState([]);
  const [allTowers, setAllTowers] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const API = process.env.REACT_APP_API_URL;
  const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  const loadNotices = async () => {
    try {
      const res = await fetch(`${API}/api/admin/notices`, { headers: authHeader });
      const data = await res.json();
      setNotices(data);
    } catch (err) {
      setError("Failed to load notices");
    }
  };

  useEffect(() => {
    loadNotices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleTower = (tower) => {
    setSelectedTowers((prev) =>
      prev.includes(tower) ? prev.filter((t) => t !== tower) : [...prev, tower]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const towers = allTowers ? ["ALL"] : selectedTowers;

    if (!title || !message || towers.length === 0) {
      setError("Title, message, and at least one tower (or All towers) are required");
      return;
    }

    try {
      const res = await fetch(`${API}/api/admin/notices`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeader },
        body: JSON.stringify({ title, message, towers }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Failed to publish notice");
      }

      setTitle("");
      setMessage("");
      setSelectedTowers([]);
      setAllTowers(false);
      setSuccess("Notice published");
      loadNotices();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${API}/api/admin/notices/${id}`, {
        method: "DELETE",
        headers: authHeader,
      });
      loadNotices();
    } catch (err) {
      setError("Failed to delete notice");
    }
  };

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>Publish Notice</h1>

        {error && <p className="admin-error">{error}</p>}
        {success && <p className="notice-success">{success}</p>}

        <form onSubmit={handleSubmit} className="notice-form">
          <label className="notice-label">
            Title
            <input
              className="notice-input"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>

          <label className="notice-label">
            Message
            <textarea
              className="notice-textarea"
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </label>

          <div className="notice-label">
            Send to
            <div className="tower-picker">
              <label className="tower-chip all-towers">
                <input
                  type="checkbox"
                  checked={allTowers}
                  onChange={(e) => setAllTowers(e.target.checked)}
                />
                All towers
              </label>

              {!allTowers &&
                TOWERS.map((t) => (
                  <label className="tower-chip" key={t}>
                    <input
                      type="checkbox"
                      checked={selectedTowers.includes(t)}
                      onChange={() => toggleTower(t)}
                    />
                    {t}
                  </label>
                ))}
            </div>
          </div>

          <button type="submit" className="approve-btn">
            Publish Notice
          </button>
        </form>

        <h2 className="notice-list-heading">Published Notices</h2>

        <div className="notice-list">
          {notices.map((n) => (
            <div className="notice-item" key={n.id}>
              <div className="notice-item-header">
                <div className="notice-item-title">{n.title}</div>
                <button className="reject-btn" onClick={() => handleDelete(n.id)}>
                  Delete
                </button>
              </div>
              <div className="notice-item-message">{n.message}</div>
              <div className="notice-item-towers">
                {n.towers.includes("ALL") ? "All towers" : n.towers.join(", ")}
              </div>
              <div className="notice-item-date">
                {new Date(n.createdAt).toLocaleString()}
              </div>
            </div>
          ))}

          {notices.length === 0 && (
            <p className="admin-empty">No notices published yet</p>
          )}
        </div>
      </div>
    </div>
  );
}